<div class="main" [class.is-mobile]="mobileQuery.matches">
  <mat-toolbar color="primary" class="toolbar">
    <button mat-icon-button (click)="snav.toggle()">
      <mat-icon>menu</mat-icon>
    </button>
    <!-- <span class="aling-img">
      <img class="app-name" src="http://ibolthost.com.br/logos/logo_Biotech.png" alt="Biotech">
    </span> -->
    <h1>Biotech</h1>
    <span class="menu-spacer"></span>
    <span class="user-name" *ngIf="user$ | async; let user">{{ user.sub }}</span>
    <!-- <button mat-icon-button >
        <mat-icon  (click)="logout()" class="menu-icon">exit_to_app</mat-icon>
    </button> -->
   
  </mat-toolbar>

  <mat-sidenav-container class="sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav #snav [mode]="mobileQuery.matches ? 'over' : 'side'" [fixedInViewport]="mobileQuery.matches"
      fixedTopGap="56" [mode]="(screenWidth > 840) ? 'side' : 'over'" [opened]="screenWidth > 840"
      [class.mat-elevation-z4]="isActive">
      <app-nav-list></app-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="content-size">
          <router-outlet></router-outlet>
      </div>
      
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>